export default "__VITE_ASSET__CEAgn4Hd__"